import { render, staticRenderFns } from "./ReviewCardSkeleton.vue?vue&type=template&id=e422f2d6&scoped=true&"
import script from "./ReviewCardSkeleton.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReviewCardSkeleton.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReviewCardSkeleton.vue?vue&type=style&index=0&id=e422f2d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e422f2d6",
  null
  
)

export default component.exports